<template>
  <v-card class="p-4">
    <section class="d-flex flex-column flex-sm-row justify-content-between">
      <h4 class="ml-1 mb-4 font-weight-bold">
        Información CRM
      </h4>
    </section>
    <v-row align-content="center" align-md="center" class="mt-3">
      <v-col cols="12" md="12" sm="12" class="py-1">
        <v-card class="mb-5 p-3">
          <h5>Codigo CRM (Pipedrive)</h5>
          <v-spacer></v-spacer>
          <v-card-text>
            <v-row align-content="center" class="my-2">
              <v-col cols="12" md="6" sm="12">
                <div class="d-flex align-items-center">
                  <v-text-field
                    v-model="form.code_crm"
                    :disabled="haveCode && !formCrmEdit"
                    clearable
                    type="number"
                    label="Codigo CRM (Pipedrive) del proyecto"
                  ></v-text-field>
                  <div>
                    <v-tooltip top v-if="haveCode && !formCrmEdit">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="blue darken-3"
                          class="mt-2"
                          icon
                          @click="setEditFormCrm(true)"
                        >
                          <v-icon small class="mx-2 text-primary">
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar código</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <div class="text-right">
                  <v-btn
                    v-if="formCrmEdit"
                    color="red darken-3"
                    outlined
                    class="mt-2 mx-2"
                    @click="setEditFormCrm(false)"
                  >
                    <small>
                      Cancelar
                    </small>
                  </v-btn>
                  <v-btn
                    :disabled="(!form.code_crm || (form.code_crm && !formCrmEdit && haveCode)) || loading"
                    color="blue darken-3"
                    class="mt-2"
                    :loading="loading"
                    @click="updateCrmCode"
                  >
                    <small class="text-white">
                      Actualizar Código
                    </small>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" v-if="loading">
        <section class="text-center mt-5">
          <v-progress-circular
            class="mt-5"
            color="primary"
            indeterminate
            size="64"
          ></v-progress-circular>
          <p class="mt-2">Cargando..</p>
        </section>
      </v-col>
      <v-col
        cols="12"
        md="12"
        sm="12"
        class="pt-0"
        v-if="dataCrmProject && dataCrmProject.crm_id"
        v-show="!loading"
      >
        <v-card class="mb-5 p-3">
          <h5>Información del CRM (Pipedrive) del proyecto</h5>
          <v-spacer></v-spacer>
          <v-row align-content="center" class="mb-2 mt-5">
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Tipo de proyecto
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{ dataCrmProject.project_type ? dataCrmProject.project_type : 'Sin tipo' }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Región
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>{{ dataCrmProject.region }}</div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Comuna
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>{{ dataCrmProject.comuna }}</div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Utilización de generador Diesel
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>{{ dataCrmProject.diesel_generator ? 'Si' : 'No' }}</div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Tipo de panel
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.panel_type ? dataCrmProject.panel_type : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Cantidad de paneles
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.panel_number ? dataCrmProject.panel_number : 'Sin número'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Potencia Peak
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{ dataCrmProject.peak_power ? `${dataCrmProject.peak_power} kWp` : 'Sin datos' }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Potencia AC
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.peak_ac_power ? `${dataCrmProject.peak_ac_power} kWac` : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Capacidad en baterías
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.battery_capacity
                      ? dataCrmProject.battery_capacity
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Material Techo
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.roof_material
                      ? dataCrmProject.roof_material
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Tipo Techo
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.roof_type
                      ? dataCrmProject.roof_type
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Nº de cliente
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.client_number
                      ? dataCrmProject.client_number
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Marca del inversor
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.invester_brand
                      ? dataCrmProject.invester_brand
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Fuente del contacto
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.contact_source
                      ? dataCrmProject.contact_source
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Superficie disponible
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.available_surface
                      ? dataCrmProject.available_surface
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Distribuidor electrico
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.electric_utility
                      ? dataCrmProject.electric_utility
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Normativa
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.normative
                      ? dataCrmProject.normative
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card-subtitle class="pb-0 font-weight-bold">
                Coordenadas del proyecto
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  {{
                    dataCrmProject.coordinates
                      ? dataCrmProject.coordinates
                      : 'Sin datos'
                  }}
                </div>
              </v-card-text>
            </v-col>
            
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="pt-0" v-if="!dataCrmProject">
        <p class="text-center">
          Sin datos actualmente
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { proyectoMethods, proyectoComputed } from '@/state/helpers'
import { authMethods, authUsuarioComputed } from '@/state/helpers'
import { permiso } from '@/helpers/authservice/obtener-permisos'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      form: {
        code_crm: null
      },
      dataCrmProject: null,
      formCrmEdit: false,
      haveCode: false,
      //Data a mover a mixin
      projectSelected: {},
      codeProject: null,
      codePlace: null,
      lugarInstalacion: {},
      rolModuloPermiso: {}
    }
  },
  async mounted() {
    await this.obtenerProyectoUsuario()
    this.codeProject = this.$route.params.codigoProyecto
    this.codePlace = this.$route.params.codigoLugarInstalacion
    this.lugarInstalacion = {
      codigo_lugar_instalacion: this.codePlace,
      codigo_proyecto: this.codeProject
    }
    let permisos = permiso.obtenerPermisos(this.user, this.$router.currentRoute.name)
    this.rolModuloPermiso = permisos
    this.getCrmDataFromProjectCodeData()
  },
  methods: {
    ...proyectoMethods,
    ...authMethods,
    ...mapActions({
      getCrmDataFromProjectCode: 'crm/getCrmDataFromProjectCode',
      updateCrmIdFromProjectCode: 'crm/updateCrmIdFromProjectCode',
      unbindCrmFromProjectCode: 'crm/unbindCrmFromProjectCode'
    }),
    obtenerProyectoUsuario() {
      this.obtenerProyecto(this.$route.params.codigoProyecto)
        .then((res) => {
          this.projectSelected = res.body
        })
        .catch((error) => {})
    },
    setEditFormCrm(value){
      this.formCrmEdit = value
    },
    async updateCrmCode(){
      this.loading = true
      let payload = {
        project_code: this.codeProject,
        crm_id: this.form.code_crm
      }
      const resp = await this.updateCrmIdFromProjectCode(payload)
      if (resp.status == 200) {
        this.$swal({
          icon: 'success',
          title: 'Excelente',
          text: 'Código actualizado correctamente',
          position: 'top-end',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true
        })
        this.setEditFormCrm(false)
        await this.getCrmDataFromProjectCodeData()
      }else if (resp.status == 404) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: resp.data.detail,
          position: 'top-end',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true
        })
        this.loading = false
      } else if (resp.status == 400) {
        this.loading = false
        this.askUnbindCrmFromCurrentProject(
          resp.data.detail.message,
          resp.data.detail.project
        )
      }
    },
    async getCrmDataFromProjectCodeData() {
      this.loading = true
      this.dataCrmProject = await this.getCrmDataFromProjectCode({
        project_code: this.codeProject
      })
      this.form.code_crm  = this.dataCrmProject ?this.dataCrmProject.crm_id : null
      this.haveCode = this.form.code_crm ? true : false 
      this.loading = false
    },
    askUnbindCrmFromCurrentProject(text, code) {
      let self = this
      this.$swal
        .fire({
          icon: 'warning',
          title: `${text}, ¿Deseas desvincular el código CRM en el proyecto ${code}?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Desvincular',
          cancelButtonText: `Cancelar`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            self.loading = true
            const resp = await self.unbindCrmFromProjectCode({
              project_code: code,
            })
            if (resp.status === 200) {
              await self.updateCrmCode()
            }
          }
        })
    },
  },
  computed: {
    ...proyectoComputed,
    ...authUsuarioComputed
  }
}
</script>

<style></style>
